import { defineMessages } from 'react-intl'

export const ProductDetailsMessages = defineMessages({
  msrp: {
    id: 'Pages.ConsumerProduct.Form.msrp',
  },
})
